import { useEffect, useRef, useState } from "react";
import { Avatar, Comment, Input } from "antd";

import {
  AiFillDislike,
  AiOutlineDislike,
  AiOutlineLike,
  AiOutlineSend,
  AiOutlineUser,
  AiTwotoneLike,
} from "react-icons/ai";

import "./ChatItem.scss";
import ChatList from "../chat-list";
import { useChat } from "..";
import moment from "moment";
import { DateFormat } from "../../../../constants";
import { useUser } from "../../../../hook";

export interface IChat {
  id?: string;
  author: string;
  datetime: string;
  content: string;
  like?: string[];
  dislike?: string[];
  children?: any[];
}

export const ChatItem = (props: Partial<IChat>) => {
  const {
    id = "",
    author = "",
    datetime = "",
    content = "",
    like = [],
    dislike = [],
    children = [],
  } = props;

  const inputChatRef = useRef<any>(null);
  const [chat, setChat] = useState("");
  const [showComment, setShowComment] = useState(false);

  const { handleAddChat, handleUpdateChat } = useChat();
  const { user } = useUser();

  const handleLikeClick = () => {
    let newLike: string[] = [];
    let newDislike: string[] = [];
    const hasLiked = like.some((e) => user.current.username);
    if (hasLiked) {
      newLike = like.filter((e) => e !== user.current.username);
    } else {
      const hasDisliked = dislike.some((e) => e === user.current.username);
      if (hasDisliked) {
        newDislike = dislike.filter((e) => e !== user.current.username);
      }
      newLike = [...like, user.current.username];
    }
    const newChat = { ...props, like: newLike, dislike: newDislike };
    handleUpdateChat(id, newChat);
  };
  const handleDislikeClick = () => {
    let newDislike: string[] = [];
    let newLike: string[] = [];
    const hasDisliked = dislike.some((e) => user.current.username);
    if (hasDisliked) {
      newDislike = dislike.filter((e) => e !== user.current.username);
    } else {
      const hasLiked = like.some((e) => e === user.current.username);
      if (hasLiked) {
        newLike = like.filter((e) => e !== user.current.username);
      }
      newDislike = [...dislike, user.current.username];
    }
    const newChat = { ...props, dislike: newDislike, like: newLike };
    handleUpdateChat(id, newChat);
  };

  const handleChatSubmit = () => {
    if (chat.trim()) {
      handleAddChat(id, chat.trim());
    }
    setChat("");
    setShowComment(false);
  };

  const isLiked = like.some((e) => e === user.current.username);
  const isDisliked = dislike.some((e) => e === user.current.username);

  const actions = [
    <span key="like" className="chat-item-action" onClick={handleLikeClick}>
      {isLiked ? (
        <AiTwotoneLike size={18} color="#00a9c4" />
      ) : (
        <AiOutlineLike size={18} />
      )}
      {like?.length || 0}
    </span>,
    <span key="like" className="chat-item-action" onClick={handleDislikeClick}>
      {isDisliked ? (
        <AiFillDislike size={18} color="red" />
      ) : (
        <AiOutlineDislike size={18} />
      )}
      {dislike?.length || 0}
    </span>,
    <span
      key="reply-to"
      className="ant-reply-to"
      onClick={() => setShowComment(true)}
    >
      Phản hồi
    </span>,
  ];

  useEffect(() => {
    if (showComment && inputChatRef.current) {
      inputChatRef.current.focus();
    }
  }, [showComment]);

  return (
    <>
      <Comment
        className="ant-chat"
        author={author}
        avatar={<Avatar alt="Han Solo" icon={<AiOutlineUser />} />}
        datetime={moment(datetime).format(DateFormat.DD_MM_YYYY_HH_MM)}
        content={content}
        actions={actions}
      >
        {Boolean(children.length) && <ChatList items={children} />}
        {showComment && (
          <Input
            ref={inputChatRef}
            style={{ marginBottom: "1rem" }}
            size="large"
            suffix={
              <AiOutlineSend
                onClick={handleChatSubmit}
                style={{ cursor: "pointer" }}
              />
            }
            placeholder="Nhập phản hồi..."
            value={chat}
            onChange={(e) => setChat(e.target.value)}
            onPressEnter={handleChatSubmit}
          />
        )}
      </Comment>
    </>
  );
};
